(function () {
    'use strict';
    jQuery.extend( true, e4.forms, {
        validate: {
            bindEvents: function () {

                jQuery.validator.addMethod('maxfilesizemb', function (value, element, param) {
                    return this.optional(element) || (element.files[0].size <= (param * 1000000))
                }, 'File size must be less than {0} mb');

                // Bind validation method to all Dynamiweb forms and custom forms with data-validate="true" using default settings.
                jQuery( '.js-e-form-dw, form[data-validate="true"]' ).each( function () {
                    jQuery( this ).validate({
                        normalizer: function( value ) {
                            return $.trim( value );
                        }, 
                        rules: {
                            Image1: {
                                maxfilesizemb: 2
                            },
                            Image2: {
                                maxfilesizemb: 2 
                            },
                            Image3: {
                                maxfilesizemb: 2
                            },
                            Image4: {
                                maxfilesizemb: 2
                            },
                            Image5: {
                                maxfilesizemb: 2
                            },
                            ImageProductId: {
                                maxfilesizemb: 2
                            },
                            Video: {
                                maxfilesizemb: 20 
                            }
                        }
                    });
                } );
            }
        }
    } );
}());